// extracted by mini-css-extract-plugin
export var collection = "collection-module--collection--Xkg4e";
export var comingSoonTitle = "collection-module--coming-soon-title--fkPFO";
export var comingSoonWrapper = "collection-module--coming-soon-wrapper--Y2zg1";
export var title = "collection-module--title--3K2Nr";